import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const QuestionMarkIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M10.3 5.4A3.2 3.2 0 0 1 15 8.2c0 1-.8 1.7-1.8 2.4a4.8 4.8 0 0 0-2.4 4v.9a1 1 0 1 0 2 0v-1c0-.8.5-1.6 1.5-2.2 1.1-.7 2.7-2 2.7-4.1A5.2 5.2 0 0 0 7 6.5a1 1 0 0 0 1.9.6 3 3 0 0 1 1.4-1.7ZM12 18a1 1 0 0 0 0 2 1 1 0 0 0 0-2Z" />
    </Icon>
  )
);
export default QuestionMarkIcon;
